import { useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  loginExpired,
  saveRedirectedFromAuthPageState,
} from './utils/sessionStorage';

export default function DoRedirects() {
  const isAuthenticated = useIsAuthenticated();
  const isLoginExpired = loginExpired();
  const location = useLocation();
  const navigate = useNavigate();

  const authenticatedPathsEn = [
    '/data-analytics-services/hub',
    '/data-analytics-services/vdl-hub',
    '/data-analytics-services/vdl-hub/upload',
    '/data-analytics-services/vdl-hub/download',
  ];

  const authenticatedPathsFr = [
    '/services-analyse-donnees/guichet',
    '/services-analyse-donnees/guichet-lvd',
    '/services-analyse-donnees/guichet-lvd/televerser',
    '/services-analyse-donnees/guichet-lvd/telecharger',
  ];

  useEffect(() => {
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      navigate(location.pathname.slice(0, -1), {
        replace: true,
      });
    } else if (!isAuthenticated || isLoginExpired) {
      if (authenticatedPathsEn.includes(location.pathname)) {
        if (!isAuthenticated) {
          saveRedirectedFromAuthPageState(true);
        }
        navigate('data-analytics-services/overview', {
          replace: true,
        });
      } else if (authenticatedPathsFr.includes(location.pathname)) {
        if (!isAuthenticated) {
          saveRedirectedFromAuthPageState(true);
        }
        navigate('services-analyse-donnees/apercu', {
          replace: true,
        });
      }
    }
  }, [location]);

  return null;
}
